import { basic, workflow } from './generators'
import merge from '../../utilities/merge'
import flatten from '../../utilities/flatten'
import oldActionTypes from './old_actionTypes'

// 0. the main actionType definitions.
// TODO: Update how we handle errors when you remove one of the actionTypeDefinitions, as currently it gives a poor error message
export const actionTypeDefinitions = {
	activateNewUser: workflow,

	appAddContextMenu: basic,

	authEmailSent: basic,
	authAlreadyVerified: basic,

	buyButtonClick: basic,
	buyClickAdd: workflow,

	checkFollowing: workflow,

	feedFetch: workflow,

	itemEdit: basic,
	itemVersionAdd: workflow,
	itemFetch: workflow,
	itemBrandFetch: workflow,
	itemFeatureVotesFetch: workflow,
	itemPostsFetch: workflow,
	itemOwnSet: workflow,
	itemWantSet: workflow,
	itemOwnWantFetch: workflow,
	itemDraftCreate: basic,

	kitFetch: workflow,
	kitShareFetch: workflow,
	kitDelete: workflow,
	kitDuplicate: workflow,
	kitPostsFetch: workflow,
	kitOwnSet: workflow,
	kitWantSet: workflow,
	kitOwnWantFetch: workflow,
	kitSuggestionsFetch: workflow,

	kitDraftSet: workflow,
	kitDraftSetFromKit: basic,
	kitDraftSetImages: basic,
	kitDraftLoadedAllUserKits: basic,
	kitDraftFetch: workflow,
	kitDraftCreate: basic,
	kitDraftClear: basic,
	kitDraftItemDelete: basic,
	kitDraftSelectItem: basic,
	kitDraftSetTags: basic,
	kitDraftTemplateUpdate: basic,
	kitDraftSetImageUrlAndKitId: basic,
	kitDraftItemsSort: basic,

	kitSuggestionSet: workflow,
	kitSuggestionDelete: workflow,
	kitSuggestionAddToDraft: basic,
	kitSuggestItem: basic,

	kudosPostSet: workflow,
	kudosPostUserFetch: workflow,

	notificationStatus: basic,
	notificationsFetch: workflow,
	notificationsMoreFetch: workflow,
	notificationsSeenSet: workflow,

	postCommentsFetch: workflow,
	postCommentAdd: workflow,
	postCommentDelete: workflow,
	postCommentDeleteByPostOwner: workflow,
	postDelete: workflow,
	postDraftFetch: workflow,
	postDraftKitFetch: workflow,
	postDraftUserKitsFetch: workflow,
	postDraftCreate: basic,
	postDraftDelete: basic,
	postDraftSet: basic,
	postDraftSetImageUrl: basic,
	postDraftAddTag: basic,
	postDraftRemoveTag: basic,
	postDraftSetTags: basic,
	postFetch: workflow,
	postFetchFollowing: workflow,
	postFollowersSet: workflow,
	postHideFromFeedSet: workflow,
	postSet: workflow,

	searchTypeSet: basic,
	searchDisplayModeSet: basic,
	searchItem: workflow,
	searchUser: workflow,
	searchKit: workflow,
	searchParametersClear: basic,

	userProfileOnboardSubmit: basic,
	userProfileFetch: workflow,
	userProfileFetchItems: workflow,
	userProfileFollowerRemove: workflow,
	userProfileFollowersFetch: workflow,
	userProfileFollowersSet: workflow,
	userProfileFollowingFetch: workflow,
	userProfileFollowingRemove: workflow,
	userProfileGetOwnProfile: basic,
	userProfileItemsOwnedFetch: workflow,
	userProfileItemsWantedFetch: workflow,
	userProfileKitAdd: workflow,
	userProfileKitsFetch: workflow,
	userProfileKitsOwnedFetch: workflow,
	userProfileKitsWantedFetch: workflow,
	userProfilePostsFetch: workflow,
	userProfileReserveUserName: workflow,
	userProfileSave: workflow,
	userProfileSetUploadedImage: workflow,
	userProfileStatisticsUpdate: basic,
	userProfileSuggest: basic,
	userProfileTabSet: basic,
	userProfileUpdate: basic,
	userProfileUpdateProfilePicture: basic,
	userProfileVerifiedFetch: workflow,
	userProfileVerifiersFetch: workflow,
	userProfileVerifiersSet: workflow
}

// 1. assert that there are no invalid group names (ending with Begin etc., unknown type identifier)
// 2. create a flat list of all of the action types
export const actionTypes = merge(flatten(Object.entries(actionTypeDefinitions).map(([name, type]) => type.generate(name))))
// 2.5 merge (for now) with the existing old style ones (not old generated ones, but the old raw ones - they could be generated anyway...)
const allActionTypes = { ...oldActionTypes, ...actionTypes }
// 3. export/import as actionTypes
export default allActionTypes // TODO: eventually will not be this that is exported...

global.KF = { ...global.KF, oldActionTypes, allActionTypes, actionTypes }



// WEBPACK FOOTER //
// ./src/redux/actionTypes/index.js